
import { computed, defineComponent, inject, reactive, watch } from 'vue'
import DimensionsIcon from '@/components/Icons/DimensionsIcon.vue'

export default defineComponent({
  name: 'EditableBlockDimensionInput',
  components: { DimensionsIcon },
  props: {
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
    prepend: {
      type: String,
    },
    append: {
      type: String,
    },
    editing: {
      type: Boolean,
      default: undefined,
    },
    min: {
      type: Number,
      default: 1
    },
    pattern: {
      type: String,
      default: '[0-9]*'
    },
    dimension: {
      type: String,
    }
  },

  emits: ['update:modelValue'],

  setup (props, { emit }) {

    const inputState = reactive({
      label: props.label,
      value: computed({ get: () => props.modelValue, set: (newValue) => emit('update:modelValue', newValue) })
    })

    let editingValue
    if (props.editing !== undefined) {
      editingValue = computed(() => props.editing)
    } else {
      editingValue = inject('editing', false)
    }

    // const state = reactive({
    //   inputUuid: uuid(),
    //   changedValue: props.modelValue,
    // })
    //
    // const changed = computed(() => state.changedValue !== props.modelValue)
    //
    // const setChanged = inject<(String, Boolean) => void>(
    //   // eslint-disable-next-line @typescript-eslint/no-empty-function
    //   'setChanged', () => {}
    // )
    //
    // onBeforeUnmount(() => setChanged(state.inputUuid, false))
    //
    // const updateValue = ($event) => state.changedValue = $event
    //
    // watch(() => props.modelValue, (newValue) => !changed.value ? updateValue(newValue) : null)
    //
    // watch(changed, (newChanged) => setChanged(state.inputUuid, newChanged))

    return {
      editingValue,
      inputState
      // ...toRefs(state),
      // changed,
      // updateValue,
    }
  }
})
